import {
  Activity,
  BarChart3,
  Building2,
  ClipboardCheck,
  Film,
  KeyRound,
  LayoutDashboard,
  ScrollText,
  Terminal,
  Users,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { Area } from '../../auth/roles';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** Marks the link active only on an exact match (the area's landing page). */
  end?: boolean;
}

/** The menu each area sees. There is no way to switch areas: your account decides. */
export const NAV: Record<Area, { title: string; items: NavItem[] }> = {
  staff: {
    title: 'Platform',
    items: [
      { to: '/staff', label: 'Overview', icon: LayoutDashboard, end: true },
      { to: '/staff/review', label: 'Review queue', icon: ClipboardCheck },
      { to: '/staff/catalog', label: 'All titles', icon: Film },
      { to: '/staff/creators', label: 'Creators', icon: Users },
      { to: '/staff/tenants', label: 'Apps (tenants)', icon: Building2 },
      { to: '/staff/audit', label: 'Activity log', icon: ScrollText },
    ],
  },
  studio: {
    title: 'Creator Studio',
    items: [
      { to: '/studio', label: 'My titles', icon: Film, end: true },
      { to: '/studio/analytics', label: 'Performance', icon: BarChart3 },
    ],
  },
  developer: {
    title: 'Developer Console',
    items: [
      { to: '/developer', label: 'API keys', icon: KeyRound, end: true },
      { to: '/developer/usage', label: 'Usage', icon: Activity },
      { to: '/developer/playground', label: 'Try the API', icon: Terminal },
    ],
  },
};
